<template>
  <div>
    <base-header class="pb-4" />

    <div class="container-fluid mt--4 pt-5 income-forms">
      <b-row>
        <b-col>
          <b-card title="Detaylar" class="mb-4" no-body>
            <b-row>
              <b-col>
                <b-form-group label="Fatura No">
                  <b-form-input v-model="invoiceNumber" placeholder="Fatura No" />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Kategori") }} <span style="color:red">*</span></legend>
                  <b-form-select v-model="category" :options="categories" />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Ödeme Tarihi") }} <span style="color:red">*</span></legend>
                  <b-form-input v-model="first_payment_date" type="date"/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Vade") }} <span style="color:red">*</span></legend>
                  <b-form-input v-model="last_payment_date" type="date"/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Ödeme Türü") }} <span style="color:red">*</span></legend>
                  <b-form-select v-model="payment_type" :options="[
                    { text: 'Nakit', value: 'cash' },
                  //  { text: 'Çek', value: 'check' },
                //    { text: 'Senet', value: 'bill' },
                    { text: 'Kredi Kartı', value: 'credit_cart' },
                    { text: 'Havale / EFT', value: 'eft' },
                  ]"/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <!-- Services -->
        <b-col>
          <b-card title="Hizmetler" no-body>
            <b-row v-for="(service, key) in services" :key="key">
              <b-col sm="12" md="3">
                <b-form-group>
                  <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Ürün / Hizmet") }} <span style="color:red">*</span></legend>
                  <v-select v-model="service.service" @input="changeService(key)" :options="servicesOptions" />
                </b-form-group>
              </b-col>
              <b-col cols="6" sm="3" md="2">
                <b-form-group>
                  <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Birim Fiyatı") }} <span style="color:red">*</span></legend>
                  <b-form-input v-model="service.price" type="number" />
                </b-form-group>
              </b-col>
              <b-col cols="6" sm="3" md="2">
                <b-form-group>
                  <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("KDV Oranı") }} <span style="color:red">*</span></legend>
                  <b-form-input v-model="service.tax" type="number" />
                </b-form-group>
              </b-col>
              <b-col cols="6" sm="3" md="2">
                <b-form-group>
                  <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("İskonto") }} <span style="color:red">*</span></legend>
                  <b-form-input v-model="service.discount" type="number" />
                </b-form-group>
              </b-col>
              <b-col cols="6" sm="3" md="2">
                <b-form-group>
                  <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Adet") }} <span style="color:red">*</span></legend>
                  <b-form-input v-model="service.piece" type="number" />
                </b-form-group>
              </b-col>
              <b-col md="1">
                <b-button @click="removeService(key)" variant="danger" class="remove-button">
                  <i class="far fa-trash-alt" />
                </b-button>
              </b-col>
              <b-col sm="12">
                <hr>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12">
                <div class="w-100 d-flex align-items-center justify-content-between" style="padding-right: 8%">
                  <b-button variant="warning" @click="addService"><i class="fas fa-plus"></i></b-button>
                  <h3 class="mt-2">Toplam KDV: {{ calculateTax() }} TL / {{ $t("Toplam Fiyat") }}: {{ calculateTotal() }} TL</h3>
                </div>
              </b-col>
            </b-row>

          </b-card>
          <div class="w-100 text-right mt-3">
            <b-button variant="secondary" @click="$emit('close')">{{ $t("Kapat") }}</b-button>
            <b-button variant="primary" class="loading-button" @click="submit" :disabled="$v.$invalid || loadingButton">
              <i v-if="loadingButton" class="fa fa-spinner"></i> {{ $t("Kayıt Oluştur") }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import moment from 'moment'
  import {required, minValue} from 'vuelidate/lib/validators'

  export default {
    props: ['clientId'],
    validations: {
      first_payment_date: {
        required,
      },
      last_payment_date: {
        required,
      },
      services: {
        $each: {
          service: {
            value: {
              required,
            }
          },
          price: {
            required,
            minValue: minValue(1),
          },
          piece: {
            required,
            minValue: minValue(1),
          },
        }
      }
    },
    data () {
      return {
        loadingButton: false,
        typeOfPayment: 'one_time',
        invoiceNumber: '',
        client: {},
        category: '',
        categories: [],
        first_payment_date: moment().format('YYYY-MM-DD'),
        last_payment_date: moment().format('YYYY-MM-DD'),
        payment_type: 'cash',
        services: [
          {
            service: '',
            price: 1,
            tax: 18,
            piece: 1,
            discount: 0,
          },
        ],
        servicesOptions: [],
        originalServices: [],
        clients: [],
      }
    },
    methods: {
      ...mapActions(['createCredit', 'getIncomeDependencies', 'updateCredit', 'editAccounting']),
      submit () {
        this.loadingButton = true;
        const services = JSON.parse(JSON.stringify(this.services)).map(item => {
          item.service_id = item.service.value
          delete item.service
          return item
        })
        const data = {
          category_id: this.category,
          type_of_payment: this.typeOfPayment,
          invoice_number: this.invoiceNumber,
          // client_id: this.client.value,
          client_id: this.clientId,
          payment_type: this.payment_type,
          services,
          first_payment_date: this.first_payment_date,
          last_payment_date: this.last_payment_date,
        };

        this.createCredit(data).then(response => {
          this.loadingButton = true;
          this.success(response.data.message)
          this.$emit('success')
        }).catch(error => {
          this.loadingButton = true;
          this.error(error.response.data.message)
        })
      },
      changeService (key) {
        const currentService = this.services[key].service
        if ( currentService ) {
          const serviceKey = this.servicesOptions.indexOf(currentService)
          this.services[key].tax = this.originalServices[serviceKey].tax
          this.services[key].price = this.originalServices[serviceKey].price
        } else {
          this.services[key].tax = 18
          this.services[key].price = 1
        }
      },
      removeService (key) {
        if ( this.services.length > 1 ) {
          this.services.splice(key, 1)
        }
      },
      // calculate total tax
      calculateTax () {
        return this.services.reduce((total, item) => {
          return total + parseFloat(this.calculateItemTax(item));
        }, 0);
      },
      // calculate total price
      calculateTotal () {
        return this.services.reduce((total, item) => {
          return total + parseFloat(this.calculateItemTotal(item));
        }, 0);
      },
      // calculate single item tax
      calculateItemTax (item) {
        return ((item.price - item.discount) * item.tax / 100) * item.piece;
      },
      // calculate single item price
      calculateItemTotal (item) {
        const total = ((parseFloat(item.price) - parseFloat(item.discount)) * item.piece)
          + parseFloat(this.calculateItemTax(item));
        return isNaN(total) ? 0 : total;
      },
      // add new service
      addService () {
        this.services.push({
          service_id: '',
          price: 1,
          tax: 18,
          piece: 1,
          discount: 0,
        })
      },
      createScreen() {
        this.getIncomeDependencies().then(data => data.data).then(response => {
          this.prepareClients(response.clients);
          this.prepareServices(response.services);
          this.categories = response.categories;
        })
      },
      prepareClients(clients) {
        this.clients = clients.map(item => {
            return {
              label: item.full_name + `(${item.company_name})`,
              value: item.id,
            }
          })
      },
      prepareServices(services) {
        this.servicesOptions = services.map(item => {
          return {
            label: item.name,
            value: item.id,
          }
        })

        this.originalServices = services
      },
      addServicesToScreen(services) {
        this.services = [];
        services.map(service => {
          this.services.push({
            service: {
              value: service.service_id,
              label: service.service.name,
            },
            price: service.price,
            tax: service.tax,
            piece: service.piece,
            discount: service.discount,
          });
        });
      }
    },
    mounted () {
      // if( this.$route.params.id ) {
      //   this.editAccounting(this.$route.params.id).then(data => data.data).then(response => {
      //     this.prepareClients(response.clients)
      //     this.prepareServices(response.services)
      //     this.categories = response.categories;
      //
      //     // services info
      //     this.invoiceNumber = response.accounting.invoice_number;
      //     this.first_payment_date = response.accounting.first_payment_date;
      //     this.last_payment_date = response.accounting.last_payment_date;
      //     this.typeOfPayment = response.accounting.typeOfPayment;
      //     this.client = {
      //       value: response.accounting.client_id,
      //       label: response.accounting.client.full_name + ' (' + response.accounting.client.company_name + ')',
      //     };
      //
      //     // add services to screen
      //     this.addServicesToScreen(response.accounting.services);
      //   });
      // } else {
      //   this.createScreen();
      // }
      this.createScreen();
    }
  }
</script>
